import { CreateShiftCardContext } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftCard/CreateShiftCard.context';
import { FC, useContext } from 'react';

import {
  AutoExtendBidToggleInputLabel,
  AutoExtendBidToggleInputWrapper,
  StyledBKJToggleInput,
  ShiftCardButtonWithNoHeight,
} from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftCard/AutoExtendBidToggleInput/AutoExtendBidToggleInput.styled';
import { useTranslation } from 'hooks/useTranslation';
import { BKJIconTooltip, Flex } from '@bookjane2/bookjane-design-library';

export const AutoExtendBidToggleInput: FC = () => {
  const {
    createShift: {
      values: { auto_extend_bid },
    },
    handleChange,
  } = useContext(CreateShiftCardContext);

  const { t } = useTranslation();

  return (
    <AutoExtendBidToggleInputWrapper>
      <ShiftCardButtonWithNoHeight variant="PurpleNoDecorations">
        <AutoExtendBidToggleInputLabel>
          {t('create_shifts:AUTO_EXTEND_BID')}?
        </AutoExtendBidToggleInputLabel>
      </ShiftCardButtonWithNoHeight>
      <BKJIconTooltip iconName="Info" placement="top">
        <Flex width="300px">{t('create_shifts:AUTO_RE_BID_INFO')}</Flex>
      </BKJIconTooltip>
      <StyledBKJToggleInput
        variant="Switch"
        name="auto_extend_bid"
        checked={!!auto_extend_bid}
        onChange={handleChange}
      />
    </AutoExtendBidToggleInputWrapper>
  );
};
